import { useEffect } from 'react';
import './App.scss';
import useToken from '../hooks/useToken/useToken';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Login from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import Unmeasured from '../pages/Unmeasured/Unmeasured';
import JobIndex from '../pages/JobIndex/JobIndex';
import JobShow from '../pages/JobShow/JobShow';
import BayIndex from '../pages/BayIndex/BayIndex';
import Bay from '../pages/Bay/Bay';
import CollectionsIndex from '../pages/CollectionsIndex/CollectionsIndex';
import DeliveriesIndex from '../pages/DeliveriesIndex/DeliveriesIndex';
import SubcontractsOutIndex from '../pages/SubcontractsOutIndex/SubcontractsOutIndex';
import SubcontractsInIndex from '../pages/SubcontractsInIndex/SubcontractsInIndex';
import ImportsIndex from '../pages/ImportsIndex/ImportsIndex';
import ExportsIndex from '../pages/ExportsIndex/ExportsIndex';
import Movement from '../pages/Movement/Movement';
import ArrivalsDepartures from '../pages/ArrivalsDepartures/ArrivalsDepartures';

const App = () => {
  const { token, setToken } = useToken();

  const checkToken = e => {
    if (e.key === 'token') setToken(e.newValue);
  };

  const handleTokenChangeEvent = e => {
    if (e.detail) localStorage.setItem('logout-message', JSON.stringify(e.detail));
  };

  /*
   * Handles when another tab clears the token
   */
  useEffect(() => {
    window.addEventListener('storage', checkToken);
    window.addEventListener('token-change-message', handleTokenChangeEvent);

    return () => {
      window.removeEventListener('storage', checkToken);
      window.removeEventListener('token-change-message', handleTokenChangeEvent);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {!token && <Route path="login" element={<Login />} />}
        {token && (
          <Route path="/">
            <Route index element={<Dashboard />} />
            <Route path="packages/missing_dimensions" element={<Unmeasured />} />
            <Route path="jobs" element={<JobIndex />} />
            <Route path="jobs/:id" element={<JobShow />} />
            <Route path="bays" element={<BayIndex />} />
            <Route path="bays/:id" element={<Bay />} />
            <Route path="collections" element={<CollectionsIndex />} />
            <Route path="collections/:id" element={<Movement />} />
            <Route path="deliveries" element={<DeliveriesIndex />} />
            <Route path="deliveries/:id" element={<Movement />} />
            <Route path="subcontracts_out" element={<SubcontractsOutIndex />} />
            <Route path="subcontracts_out/:id" element={<Movement />} />
            <Route path="subcontracts_in" element={<SubcontractsInIndex />} />
            <Route path="subcontracts_in/:id" element={<Movement />} />
            <Route path="imports" element={<ImportsIndex />} />
            <Route path="imports/:id" element={<Movement />} />
            <Route path="exports" element={<ExportsIndex />} />
            <Route path="exports/:id" element={<Movement />} />
            <Route path="arrivals" element={<ArrivalsDepartures />} />
          </Route>
        )}
        <Route
          path="*"
          element={<Navigate to={token ? '/' : '/login'} state={location.pathname} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
